import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Client1 from '../assets/img/client1.png';
import Client2 from '../assets/img/client2.png';
import Client3 from '../assets/img/client3.png';
import Client4 from '../assets/img/client4.png';
import Client5 from '../assets/img/client5.png';
import Client6 from '../assets/img/client6.png';
import Client7 from '../assets/img/client7.png';
import Client8 from '../assets/img/client8.png';
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";


const Clients=()=>{
    const responsive = {
        superLargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 4000, min: 3000 },
          items: 8
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 5
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 3
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 2
        }
    };

    return(
       <section className='clients' id='clients'>
            <Container>
                <h1 className='servhdng clientshdng'>Our Clients</h1>
                <p className='servheadpara clientspara'>We are grateful for the wonderful testimonials from our happy and beloved clients.From local business leaders and coaches to Fortune 500 executives</p>
                <Carousel responsive={responsive} infinite={true} autoPlaySpeed={1000} 
                autoPlay={true} swipeable={false} draggable={true} showDots={false} 
                arrows={false} className='client-slider'>
                    <img src={Client1} alt="client" className="client-img" />
                    <img src={Client2} alt="client" className="client-img" />
                    <img src={Client3} alt="client" className="client-img" />
                    <img src={Client4} alt="client" className="client-img" />
                    <img src={Client5} alt="client" className="client-img" />
                    <img src={Client6} alt="client" className="client-img" />
                    <img src={Client7} alt="client" className="client-img" />
                    <img src={Client8} alt="client" className="client-img" />
                </Carousel>
            </Container>
        </section>
    )
}

export default Clients